// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"bvdFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _database = require("firebase/database");
var _common = require("./common");
var _config = require("./config");
var _phUserSvg = require("url:../images/svg/ph-user.svg");
var _phUserSvgDefault = parcelHelpers.interopDefault(_phUserSvg);
var _volJpg = require("url:../images/pexel/vol.jpg");
var _volJpgDefault = parcelHelpers.interopDefault(_volJpg);
var _translator = require("../custom/translator");
var _storage = require("firebase/storage");
const zeffy_default = 'donate-to-change-lives-6222';
let activeLs = [];
let dbRef;
let dbAuthor;
let authorData = null;
let authorFetchPromise = null;
$(document).ready(function() {
    $(function() {
        initDomLs();
        initUi();
        getCampInfo(getSlug());
    });
});
function initDomLs() {
    window.addEventListener('beforeunload', ()=>{
        activeLs.forEach((stopLs)=>{
            stopLs();
        });
    });
}
async function getCampInfo(pathParts) {
    if (!pathParts || pathParts.length !== 2) {
        console.error('Invalid path parts:', pathParts);
        const location = window.location.pathname;
        console.log('location: ', location);
        if (location == '/piztio') return;
        //show dialog to inform the user about the invalid path
        showErrorDialog();
    }
    try {
        (0, _config.initFb)();
        dbRef = (0, _database.getDatabase)();
        const campId = await getCampId(pathParts[1]);
        const dbCamp = (0, _database.ref)(dbRef, `campaign/${campId}`);
        // add data listener for the campaign
        const unsub = (0, _database.onValue)(dbCamp, async (snapshot)=>{
            if (snapshot.exists()) {
                const campData = snapshot.val();
                campData.id = campId;
                // 1. Fetch data safely (pauses on 1st run, instant on subsequent runs)
                await getAuthorInfo(campData, pathParts[0]);
                // 2. Keep all your UI rendering explicitly together in order
                initAuthorUi();
                updateCampUi(campData);
                //get past campaigns only once
                getPastCampaigns(campId);
            } else {
                console.error('Campaign not found');
                showErrorDialog();
            }
        });
        activeLs.push(unsub);
        getCampMedia(campId);
    } catch (error) {
        console.error('Error setting campaign UI:', error);
        showErrorDialog();
    }
}
async function getPastCampaigns(currentCampId) {
    if (authorData === null) return;
    const dbPast = (0, _database.ref)(dbRef, `pastUserCamp/${authorData.uid}`);
    const existQuery = (0, _database.query)(dbPast, (0, _database.limitToFirst)(1));
    const exist = await (0, _database.get)(existQuery);
    const unsub = (0, _database.onChildAdded)(dbPast, (snapshot)=>{
        if (snapshot.exists()) {
            const key = snapshot.key;
            if (key !== currentCampId) getPastCampInfo(key);
        }
    });
    const unsubRemove = (0, _database.onChildRemoved)(dbPast, (snapshot)=>{
        if (snapshot.exists()) {
            const key = snapshot.key;
            const campCard = document.getElementById(key || '');
            if (campCard) campCard.remove();
        }
    });
    activeLs.push(unsubRemove);
    activeLs.push(unsub);
    const campaignContainer = document.querySelector('.campaign-wrapper');
    if (campaignContainer) (0, _common.toggleSkeleton)(false, campaignContainer);
}
async function getPastCampInfo(key) {
    if (!key) return;
    const dbPastCamp = (0, _database.ref)(dbRef, `campaign/${key}`);
    const campInfo = await (0, _database.get)(dbPastCamp);
    if (campInfo.exists()) {
        const pastCampData = campInfo.val();
        const campCard = (0, _common.createCampaignCard)();
        campCard.id = pastCampData.id || '';
        campCard.querySelector('.campaign-title').textContent = pastCampData.title || '';
        campCard.querySelector('.campaign-image').src = pastCampData.cover || '';
        campCard.querySelector('.campaign-btn').href = `/${authorData.username}/${pastCampData.slug}`;
        document.querySelector('.campaign-container')?.appendChild(campCard);
    }
}
async function getCampMedia(campId) {
    if (!campId) return;
    //clear gallery grid before adding new media
    const galleryGrid = document.querySelector('.gallery-grid');
    const backupGalleryGrid = galleryGrid ? galleryGrid.innerHTML : '';
    if (galleryGrid) galleryGrid.innerHTML = '';
    const dbMedia = (0, _database.ref)(dbRef, `campMedia/${campId}`);
    const singleQuery = (0, _database.query)(dbMedia, (0, _database.limitToFirst)(1));
    const exists = await (0, _database.get)(singleQuery);
    if (!exists.exists()) // If no media exists, restore the backup gallery grid
    {
        if (galleryGrid) galleryGrid.innerHTML = backupGalleryGrid;
    }
    const unsub = (0, _database.onChildAdded)(dbMedia, (snapshot)=>{
        if (snapshot.exists()) {
            const url = snapshot.val();
            const mediaData = {
                id: snapshot.key || galleryGrid?.children.length || 0,
                url: url
            };
            // Handle media data (e.g., update gallery)
            addCampMedia(mediaData);
        }
    });
    const onRemoved = (0, _database.onChildRemoved)(dbMedia, (snapshot)=>{
        if (snapshot.exists()) {
            const mediaData = snapshot.val();
            const mediaItem = document.getElementById(mediaData.id || '');
            if (mediaItem && galleryGrid) {
                galleryGrid.removeChild(mediaItem);
                if (galleryGrid.children.length === 0) galleryGrid.innerHTML = backupGalleryGrid;
            }
        }
    });
    (0, _common.toggleSkeleton)(false, document.querySelector('.gallery-section'));
    activeLs.push(onRemoved);
    activeLs.push(unsub);
}
async function addCampMedia(mediaData) {
    const galleryGrid = document.querySelector('.gallery-grid');
    if (!galleryGrid) return;
    const type = await getMediaType(mediaData.url);
    const imgWrapper = (0, _common.createMediaItem)(type);
    imgWrapper.id = mediaData.id || '';
    imgWrapper.querySelector('.media-src').src = mediaData.url;
    galleryGrid.appendChild(imgWrapper);
    addMediaLs(imgWrapper);
}
function addMediaLs(item) {
    const lightbox = document.getElementById('gallery-lightbox');
    const lightboxImg = document.getElementById('lightbox-img');
    const lightboxVideo = document.getElementById('lightbox-video');
    const captionText = document.getElementById('lightbox-caption');
    item.addEventListener('click', ()=>{
        const mediaType = item.getAttribute('data-type');
        const img = item.querySelector('img');
        const vid = item.querySelector('video');
        lightbox.style.display = 'block';
        captionText.textContent = img ? img.alt : 'Campaign Media';
        // Reset displays
        lightboxImg.style.display = 'none';
        lightboxVideo.style.display = 'none';
        lightboxVideo.pause(); // Pause any previous running streams
        if (mediaType === 'video' || vid != null) {
            const videoSrc = item.getAttribute('data-src');
            lightboxVideo.src = videoSrc || vid.src;
            lightboxVideo.style.display = 'block';
            lightboxVideo.load();
            lightboxVideo.play(); // Auto-plays when clicked
        } else {
            // Default to image display routing
            lightboxImg.src = img.src;
            lightboxImg.style.display = 'block';
        }
    });
}
async function getMediaType(url) {
    if (!url) return null;
    const extension = url.split('.').pop().toLowerCase();
    if ([
        'mp4',
        'webm',
        'ogg'
    ].includes(extension)) return 'video';
    else if ([
        'jpg',
        'jpeg',
        'png',
        'gif',
        'bmp',
        'svg'
    ].includes(extension)) return 'image';
    else {
        const storage = (0, _storage.getStorage)();
        const fileRef = (0, _storage.ref)(storage, url);
        const metadata = await (0, _storage.getMetadata)(fileRef);
        if (metadata && metadata.contentType) {
            const contentType = metadata.contentType.toLowerCase();
            if (contentType.startsWith('video/')) return 'video';
            else if (contentType.startsWith('image/')) return 'image';
        }
        return '';
    }
}
async function updateCampUi(campData) {
    //todo: some translations missing
    const campTitle = document.getElementById('campTitle');
    const campDescription = document.getElementById('campDesc');
    const campProgram = document.getElementById('campProgram');
    const campImg = document.getElementById('campImg');
    if (campImg) {
        campImg.onload = ()=>{
            (0, _common.toggleSkeleton)(false, document.getElementById('coverSect'));
        };
        campImg.onerror = ()=>{
            (0, _common.toggleSkeleton)(false, document.getElementById('coverSect'));
            campImg.src = (0, _volJpgDefault.default);
        };
        // if (campImg.complete) {
        //   toggleSkeleton(false, document.getElementById('coverSect'));
        // }
        campImg.src = campData.cover || (0, _volJpgDefault.default);
    }
    if (campTitle) {
        campTitle.setAttribute('data-i18n', ``);
        campTitle.textContent = campData.title || '';
    }
    if (campDescription) {
        campDescription.setAttribute('data-i18n', ``);
        campDescription.textContent = campData.desc || '';
    }
    if (campProgram) {
        campProgram.setAttribute('data-i18n', `${(0, _common.campaignPrograms).find((p)=>p.val === campData.program)?.i18n}`);
        (0, _translator.i18n).translatePage(campProgram);
    }
    const donationAppeal = document.getElementById('donationAppeal');
    if (donationAppeal) {
        donationAppeal.setAttribute('data-i18n-data', `{"name":"${authorData?.name || 'Por Un Mundo Mejor'}"}`);
        (0, _translator.i18n).translatePage(donationAppeal);
    }
    console.log('zeffy camp: ', campData.zeffy);
    const zeffyIframe = document.getElementById('zeffyIframe');
    if (zeffyIframe) {
        zeffyIframe.setAttribute('data-i18n-data', `{"campaign":"${campData.zeffy || zeffy_default}"}`);
        (0, _translator.i18n).translatePage(zeffyIframe);
    }
    const donationBtn = document.getElementById('donationBtn');
    if (donationBtn) {
        donationBtn.setAttribute('data-i18n-data', `{"campaign":"${campData.zeffy || zeffy_default}"}`);
        (0, _translator.i18n).translatePage(donationBtn);
    }
    const customHeader = document.querySelector('custom-header');
    if (customHeader) customHeader.setAttribute('zeffy-campaign', campData.zeffy || zeffy_default);
    if (campData.usd1) {
        const donationLevels = document.getElementById('donationLevels');
        if (donationLevels) {
            const levels = `
        <li>
          <strong>${campData.usd1}</strong>
          <span data-i18n="">${campData.info1 ?? 'error'}</span>
        </li>
        <li>
          <strong>${campData.usd2}</strong>
          <span data-i18n="">${campData.info2 ?? 'error'}</span>
        </li>
        <li>
          <strong>${campData.usd3}</strong>
          <span data-i18n="">${campData.info3 ?? 'error'}</span>
        </li>
        <li>
          <strong>${campData.usd4}</strong>
          <span data-i18n="">${campData.info4 ?? 'error'}</span>
        </li>
      `;
            //remove li element with error content
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = levels;
            const lis = tempDiv.querySelectorAll('li');
            lis.forEach((li)=>{
                if (li.querySelector('span')?.textContent.includes('error')) li.remove();
            });
            donationLevels.innerHTML = tempDiv.innerHTML;
            (0, _translator.i18n).translatePage(donationLevels);
        }
    }
    (0, _common.toggleSkeleton)(false, document.getElementById('donationArea'));
    (0, _common.toggleSkeleton)(false, document.getElementById('infoSect'));
    (0, _common.toggleSkeleton)(false, document.getElementById('projectAreas'));
}
async function getAuthorInfo(campData, username) {
    // 1. If we already have the data, just run the UI initializer and exit
    if (authorData) {
        initAuthorUi();
        return;
    }
    // 2. If a fetch is already in progress, wait for that exact same fetch to finish
    if (authorFetchPromise) {
        await authorFetchPromise;
        initAuthorUi();
        return;
    }
    // 3. First time execution: Setup the reference and create the fetch promise
    dbAuthor = (0, _database.ref)(dbRef, `user/${campData.uid}`);
    // Store the promise globally so parallel/subsequent calls can await it
    authorFetchPromise = (0, _database.get)(dbAuthor).then((snapshot)=>{
        if (snapshot.exists()) {
            const uid = snapshot.key;
            authorData = {
                uid,
                username,
                ...snapshot.val()
            };
        } else console.error('Author not found');
    }).catch((error)=>{
        console.error('Error fetching author:', error);
        authorFetchPromise = null; // Reset on error so it can retry if needed
    });
    // Wait for our fetch to complete, then initialize the UI
    await authorFetchPromise;
//initAuthorUi();
}
function initAuthorUi() {
    if (!authorData) return;
    const authorNameElem = document.getElementById('campAuthor');
    const authorImg = document.getElementById('campAuthorImg');
    if (authorNameElem) {
        authorNameElem.setAttribute('data-i18n-data', `{"name": "${authorData.name}"}`);
        authorNameElem.textContent = (0, _translator.i18n).t('camp_intro', {
            name: authorData.name
        }) || '';
    }
    if (authorImg) authorImg.src = authorData.imgUrl || (0, _phUserSvgDefault.default);
}
async function showErrorDialog() {
    await (0, _translator.i18n).changeLanguage((0, _translator.i18n).currentLang, [
        'common',
        'club'
    ]);
    const title = (0, _translator.i18n).t('camp_not_found');
    console.log('title error: ', title);
    const confirmed = await (0, _common.showSingleConfirmDialog)({
        title: 'camp_not_found',
        message: 'error_camp_msg',
        confirmText: 'ok',
        confirmType: 'danger'
    });
    if (confirmed) window.location.href = '/';
}
async function getCampId(slug) {
    const dbCampSlug = (0, _database.ref)(dbRef, `campSlugId/${slug}`);
    const snapshot = await (0, _database.get)(dbCampSlug);
    if (snapshot.exists()) return snapshot.val();
    else {
        console.error('Campaign ID not found for slug:', slug);
        return null;
    }
}
function getSlug() {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    if (pathParts.length === 2) return pathParts;
    return null;
}
function initUi() {
    const lightbox = document.getElementById('gallery-lightbox');
    const lightboxImg = document.getElementById('lightbox-img');
    const captionText = document.getElementById('lightbox-caption');
    const closeBtn = document.querySelector('.lightbox-close');
    initMediaUi();
    const navToggle = document.querySelector('.nav-toggle');
    const navLinks = document.querySelector('.nav-links');
    if (navToggle && navLinks) {
        navToggle.addEventListener('click', ()=>{
            // Toggle the animation utility classes on both elements
            navToggle.classList.toggle('is-active');
            navLinks.classList.toggle('is-active');
        });
        // Close the menu automatically if a user clicks an internal link
        navLinks.querySelectorAll('a:not(.dropdown-trigger)').forEach((link)=>{
            link.addEventListener('click', ()=>{
                navToggle.classList.remove('is-active');
                navLinks.classList.remove('is-active');
            });
        });
    }
    // 2. NEW: Submenu Toggle for Mobile Touchscreens
    const dropdownTrigger = document.querySelector('.dropdown-trigger');
    const navDropdown = document.querySelector('.nav-dropdown');
    if (dropdownTrigger && navDropdown) dropdownTrigger.addEventListener('click', (e)=>{
        // Only run this logic on mobile screens
        if (window.innerWidth <= 1000) {
            e.preventDefault(); // Stop the browser from instantly following the '#' link
            navDropdown.classList.toggle('is-open'); // Toggles open/closed states cleanly
        }
    });
}
function initMediaUi() {
    const lightbox = document.getElementById('gallery-lightbox');
    const lightboxImg = document.getElementById('lightbox-img');
    const lightboxVideo = document.getElementById('lightbox-video');
    const captionText = document.getElementById('lightbox-caption');
    const closeBtn = document.querySelector('.lightbox-close');
    document.querySelectorAll('.gallery-item').forEach((item)=>{
        item.addEventListener('click', ()=>{
            const mediaType = item.getAttribute('data-type');
            const img = item.querySelector('img');
            const vid = item.querySelector('video');
            lightbox.style.display = 'block';
            captionText.textContent = img ? img.alt : 'Campaign Media';
            // Reset displays
            lightboxImg.style.display = 'none';
            lightboxVideo.style.display = 'none';
            lightboxVideo.pause(); // Pause any previous running streams
            if (mediaType === 'video' || vid != null) {
                const videoSrc = item.getAttribute('data-src');
                lightboxVideo.src = videoSrc || vid.src;
                lightboxVideo.style.display = 'block';
                lightboxVideo.load();
                lightboxVideo.play(); // Auto-plays when clicked
            } else {
                // Default to image display routing
                lightboxImg.src = img.src;
                lightboxImg.style.display = 'block';
            }
        });
    });
    // Clean Close Controller Function
    const closeLightbox = ()=>{
        lightbox.style.display = 'none';
        lightboxVideo.pause(); // Automatically halts audio tracks on close
        lightboxVideo.src = ''; // Unloads stream to save browser memory resources
    };
    closeBtn.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (e)=>{
        if (e.target === lightbox) closeLightbox();
    });
}

},{"firebase/database":"3h9CB","./common":"jYzpo","./config":"324tf","url:../images/svg/ph-user.svg":"5j1ph","url:../images/pexel/vol.jpg":"eLW3I","../custom/translator":"eJcTf","firebase/storage":"9JHfQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5j1ph":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kDufI");

},{}],"eLW3I":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gLzDf");

},{}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["bvdFy"], "bvdFy", "parcelRequiredd39", {})

//# sourceMappingURL=piztio.e6165490.js.map
